import ANIMATION_TYPES from 'constants/animationTypes'

export function setAnimation (targetScene, currentScene, prevScene, animationProgress) {
  if (animationProgress === 0) {
    if (targetScene === currentScene) {
      return (prevScene > currentScene) ? ANIMATION_TYPES.IN_REVERSED : ANIMATION_TYPES.IN
    } else if (targetScene === prevScene) {
      return (prevScene < currentScene) ? ANIMATION_TYPES.OUT : ANIMATION_TYPES.OUT_REVERSED
    }
  } else {
    prevScene = currentScene
    currentScene = (animationProgress > 0) ? prevScene + 1 : prevScene - 1
    // console.log('setAnimation', currentScene, prevScene, animationProgress)
    animationProgress = Math.abs(animationProgress)
    if (targetScene === currentScene) {
      // console.log('animating current scene', currentScene)
      return (prevScene > currentScene)
        ? { type: ANIMATION_TYPES.IN_REVERSED, progress: animationProgress }
        : { type: ANIMATION_TYPES.IN, progress: animationProgress }
    } else if (targetScene === prevScene) {
      // console.log('animating previous scene', prevScene)
      return (prevScene < currentScene)
        ? { type: ANIMATION_TYPES.OUT, progress: animationProgress }
        : { type: ANIMATION_TYPES.OUT_REVERSED, progress: animationProgress }
    }
  }

  return ANIMATION_TYPES.NONE
}



// WEBPACK FOOTER //
// ./src/templates/coffee/utils.js